export const WPEFiles = () => {
  return <div>SEFiles</div>;
};
